"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardPool = exports.RewardPoolData = exports.RewardVault = void 0;
const rewardProgram_1 = require("../rewardProgram");
const common_1 = require("@everlend/common");
const program_1 = require("../program");
const buffer_1 = require("buffer");
class RewardVault extends common_1.Borsh.Data {
}
exports.RewardVault = RewardVault;
_a = RewardVault;
RewardVault.SCHEMA = _a.struct([
    ['bump', 'u8'],
    ['rewardMint', 'publicKey'],
    ['indexWithPrecision', 'u128'],
    ['feeAccount', 'publicKey'],
]);
const map = (type, fields) => {
    const entries = type.map((v, i) => {
        return [v, { kind: 'struct', fields: fields[i] }];
    });
    return new Map(entries);
};
class RewardPoolData extends common_1.Borsh.Data {
}
exports.RewardPoolData = RewardPoolData;
_b = RewardPoolData;
RewardPoolData.SCHEMA = map([RewardVault, _b], [
    [
        ['bump', 'u8'],
        ['rewardMint', 'publicKey'],
        ['indexWithPrecision', 'u128'],
        ['feeAccount', 'publicKey'],
    ],
    [
        ['accountType', 'u8'],
        ['rewardsRoot', 'publicKey'],
        ['bump', 'u8'],
        ['liquidityMint', 'publicKey'],
        ['totalShare', 'u64'],
        ['vaults', [RewardVault]],
        ['depositAuthority', 'publicKey'],
    ],
]);
class RewardPool extends common_1.Account {
    constructor(publicKey, info) {
        super(publicKey, info);
        if (!this.assertOwner(rewardProgram_1.RewardProgram.PUBKEY)) {
            throw common_1.Errors.ERROR_INVALID_OWNER();
        }
        this.data = RewardPoolData.deserialize(this.info.data);
    }
    static getVaultPDA(rewardMint, rewardPool) {
        return program_1.GeneralPoolsProgram.findProgramAddress([
            buffer_1.Buffer.from('vault'),
            rewardPool.toBuffer(),
            rewardMint.toBuffer(),
        ]);
    }
}
exports.RewardPool = RewardPool;
//# sourceMappingURL=rewardPool.js.map